import { useState, useCallback } from 'react';

// antd
import { Form, message } from 'antd';

// api
import { fetchSubmitDocFeedback } from 'src/api/pages/documentApi';

// type
import { IInitialValues } from './type';

const useSelection = (docLang?: string, docVersion?: string) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState<IInitialValues>(() => {
        return {
            text: '',
            type: ['error'],
            desc: '',
            email: ''
        };
    });
    const [form] = Form.useForm();

    const options = [
        { label: '描述不清楚', value: 'desc' },
        { label: '内容错误', value: 'error' },
        { label: '代码/图片/链接缺失', value: 'resource' },
        { label: '其他', value: 'other' }
    ];

    const showModal = useCallback(() => setIsModalOpen(true), []);
    const handleOk = () => {
        form.submit();
        setIsModalOpen(false);
    };
    const handleCancel = () => setIsModalOpen(false);
    const onFinish = async (values: IInitialValues) => {
        const params = {
            ...values,
            type: values.type[0],
            docLink: window.location.pathname,
            docLang: docLang?.includes('En') ? 'en' : 'zh' ?? 'zh',
            docVersion: docVersion ?? '2.3'
        };
        const result = await fetchSubmitDocFeedback(params).catch(() => {});

        if (result?.hasOwnProperty('body') && result.body?.errorCode === 0) {
            message.success('文档反馈提交成功');
        }
    };
    const onValuesChange = (
        _: Partial<IInitialValues>,
        values: Pick<IInitialValues, 'text' | 'desc' | 'email'> & { type: string[] }
    ) => {
        if (values.type === initialValues.type) {
            return;
        }

        if (values.type.length === 0) {
            form.setFieldsValue({ ...values, type: initialValues.type });
        }

        for (const item of values.type) {
            if (!initialValues.type.includes(item)) {
                setInitialValues({ ...values, type: [item] });
                form.setFieldsValue({ ...values, type: [item] });
            }
        }
    };

    return {
        isModalOpen,
        initialValues,
        options,
        form,

        showModal,
        handleOk,
        handleCancel,
        onFinish,
        onValuesChange
    };
};

export default useSelection;
